<template>
  <div>
    <wd-navbar class="tarbar">
      <div slot="left" class="middle" @click="$goBack">
        <wd-icon name="arrow-left" />
      </div>
      <div style="white-space: nowrap">
        <span style="white-space: nowrap">{{
          equipInfo.equipmentName || '--'
        }}</span>
      </div>
    </wd-navbar>
    <div>
      <div>
        <!-- AAA -->
        <van-cell
          title="开始时间"
          :value="$moment(searchObject.startDate).format('YYYY-MM-DD')"
          @click="() => dataTimeClick('start', true)"
        />
        <van-popup
          v-model="datePickerObj.startDateShow"
          round
          position="bottom"
          :style="{ height: '50%' }"
          :close-on-click-overlay="false"
        >
          <van-datetime-picker
            v-model="searchObject.startDate"
            type="date"
            title="选择年月日"
            @cancel="() => dataTimeClick('start', false)"
            @confirm="() => dataTimeClick('start', false)"
          />
        </van-popup>
        <van-cell
          title="结束时间"
          :value="$moment(searchObject.endDate).format('YYYY-MM-DD')"
          @click="() => dataTimeClick('end', true)"
        />
        <van-popup
          v-model="datePickerObj.endDateShow"
          round
          position="bottom"
          :style="{ height: '50%' }"
          :close-on-click-overlay="false"
        >
          <van-datetime-picker
            v-model="searchObject.endDate"
            type="date"
            title="选择年月日"
            @cancel="() => dataTimeClick('end', false)"
            @confirm="() => dataTimeClick('end', false)"
          />
        </van-popup>
      </div>

      <!-- <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      /> -->
      <wd-cell title="用量合计">
        <font style="font-size: 18px; color: #fa4350"
          >{{ dataInfo.totalUsage || '0'
          }}<font v-if="equipInfo.equipmentType == '0'">度</font
          ><font v-else>吨</font></font
        >
      </wd-cell>
      <div style="display: flex; align-items: center; justify-content: center">
        <wd-button class="button" @click="getList">
          <img
            src="../../assets/img/search.svg"
            alt=""
            style="width: 18px; margin-right: 5px"
          />
          搜 索
        </wd-button>
      </div>
    </div>
    <wd-cell-group>
      <wd-cell title="昨日用量" class="group-list-cell">
        <font style="font-size: 16px; color: #1f6ecf"
          >{{ dataInfo.lastDayUsage || '0'
          }}<font v-if="equipInfo.equipmentType == '0'">度</font
          ><font v-else>吨</font></font
        >
      </wd-cell>
      <wd-cell title="前日用量" class="group-list-cell">
        <font style="font-size: 16px; color: #1f6ecf"
          >{{ dataInfo.lastTwoDayUsage || '0'
          }}<font v-if="equipInfo.equipmentType == '0'">度</font
          ><font v-else>吨</font></font
        >
      </wd-cell>
    </wd-cell-group>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  data() {
    return {
      searchObject: {
        startDate: '',
        endDate: '',
      },
      equipInfo: {},
      dataInfo: {},
      // AAA
      datePickerObj: {
        startDateShow: false,
        endDateShow: false,
      },
    }
  },
  created() {
    this.searchObject.startDate = new Date(
      this.$moment()
        .subtract(3, 'days')
        .format('YYYY-MM-DD')
    )

    this.searchObject.endDate = new Date(this.$moment().format('YYYY-MM-DD'))
    this.equipInfo = this.$route.params
    if (!this.equipInfo.id) {
      this.$router.push('/selectEquip')
    } else {
      if (!this.equipInfo.equipmentName) {
        this.equipInfo.equipmentName = this.equipInfo.acctName
      }
      if (!this.equipInfo.equipmentType) {
        this.equipInfo.equipmentType = this.equipInfo.acctType
      }
      this.getList()
    }
  },
  methods: {
    getList() {
      let startDate = `${this.$moment(this.searchObject.startDate).format(
        'YYYY-MM-DD'
      )} 00:00:00`
      let endDate = `${this.$moment(this.searchObject.endDate).format(
        'YYYY-MM-DD'
      )} 23:59:59`
      let params = {
        id: this.equipInfo.id,
        startDate: startDate,
        endDate: endDate,
      }

      this.$http.post('/external/bill', params).then((res) => {
        if (res.code == 200) {
          this.$set(this.dataInfo, 'totalUsage', res.totalUsage)
          this.$set(this.dataInfo, 'lastTwoDayUsage', res.lastTwoDayUsage)
          this.$set(this.dataInfo, 'lastDayUsage', res.lastDayUsage)
        }
      })
    },
    dataTimeClick(type, show) {
      let handleObj = {
        start: {
          showType: 'startDateShow',
        },
        end: {
          showType: 'endDateShow',
        },
      }
      const { showType } = handleObj[type]
      if (show == true) return (this.datePickerObj[showType] = show)

      const startDateTime = new Date(this.searchObject.startDate).getTime()
      const endDateTime = new Date(this.searchObject.endDate).getTime()

      if (startDateTime > endDateTime) {
        Toast({
          message: '开始时间不能大于结束时间',
          position: 'top',
        })
        return
      }

      this.datePickerObj[showType] = show
    },
  },
}
</script>

<style lang="less" scoped>
.button {
  /deep/ .wd-button__txt {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.tarbar {
  /deep/ .wd-navbar__title {
    flex: 5;
    white-space: nowrap;
    overflow: visible;
  }
}
</style>
